module.exports = (str, maxlen) => {
  str = str || '';
  if (str.length <= maxlen) return str;
  return str.substr(0, maxlen) + '...';
};
